import { useEffect, useState } from 'react';
import { api } from '../lib/api';

const useSiteSettings = () => {
  const [settings, setSettings] = useState<any>(null);

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const data = await api.get('/settings');
        if (data && data.length > 0) {
          const settingsObj: any = {};
          data.forEach((item: any) => {
              settingsObj[item.setting_key] = item.setting_value;
          });
          setSettings(settingsObj);
        }
      } catch (error) {
        console.error('Load settings error:', error);
      }
    };

    loadSettings();
  }, []);

  return settings;
};

export { useSiteSettings };
export default useSiteSettings;
